import { ThunkResult } from 'store/types';
import { createAction } from 'typesafe-actions';
import { DetectedObjectTypes } from 'types';
import DataExtractionDefinitionsRepository from 'services/api-repositories/dataExtractions/DataExtractionDefinitionsRepository';
import { DataExtractionDefinitionsActionTypes } from './types';

export const setDataExtractionDefinitionsActionTypesAction = createAction(
  DataExtractionDefinitionsActionTypes.SET_DATA_EXTRACTION_DEFINITIONS,
)<DetectedObjectTypes>();

export const loadDataExtractionDefinitionsActionTypesAction = createAction(
  DataExtractionDefinitionsActionTypes.LOAD_DATA_EXTRACTION_DEFINITIONS,
)();

export const loadDataExtractionDefinitionsAction = (): ThunkResult =>
  async function loadDataExtractionDefinitionsActionTypesThunk(dispatch) {
    const receivedDataExtractionDefinitions =
      await DataExtractionDefinitionsRepository.getDataExtractionDefinitions();
    dispatch(setDataExtractionDefinitionsActionTypesAction(receivedDataExtractionDefinitions));
  };
